import { render, staticRenderFns } from "./EditAddGoNoGoItemDialog.vue?vue&type=template&id=bf3c7b12"
import script from "./EditAddGoNoGoItemDialog.vue?vue&type=script&lang=js"
export * from "./EditAddGoNoGoItemDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAddGoNoGoItemDialog.vue?vue&type=style&index=0&id=bf3c7b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports